import {Label} from '@primer/react'

import labelStyles from '../../stack-section/EntryStatusLabel.module.css'
import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function RebasedLabel({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Rebased) return null

  return (
    <Label variant="success" className={labelStyles.solid}>
      Rebased
    </Label>
  )
}
